export class RealAssistSessionDto {
  sessionId: string;
  userId: string;
  createdAt: Date;
  updatedAt: Date;
  messages: RealAssistMessageDto[];
}

export class RealAssistMessageDto {
  responseId: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  feedback?: 'positive' | 'negative' | null;
}
